import React, { useEffect, useState } from 'react';
import { BwjPageContent } from '../../../../framework/components/bwj-page-content';
import { BwjPageHeader } from '../../../../framework/components/bwj-page-header';
import { AppRoutes } from '../../../app-routes';
import { BwjViewManager, BwjViewState } from '../../../../framework/components/bwj-view-manager';
import { useNavigator } from '../../../../framework/services/navigation';
import { IStormDoorListing } from '../../../../entities-generated/models/storm-door/storm-door-listing';
import { StormDoorApiClient } from '../../../../services/storm-door';
import { StormDoorListItem } from '../../components/door-listing';


export const PageViewStormDoors: React.FunctionComponent = () => {
  const nav = useNavigator();
  const [viewState, setViewState] = useState(BwjViewState.Loading);
  const [doors, setDoors] = useState<IStormDoorListing[]>([]);

  useEffect(() => {
    StormDoorApiClient.getStormDoorList()
    .then(doors => {
      setDoors(doors);
      setViewState(BwjViewState.Ready);
    })
    .catch(() => setViewState(BwjViewState.Error));
  }, []);

  const onDoorSelected = (door: IStormDoorListing) => {
    nav.goTo(AppRoutes.editStormDoor.url(door.id));
  }

  return (
    <BwjViewManager
      state={viewState}
      loadingState={{
        message: 'Loading Storm Doors...',
      }}
      errorState={{
        message: 'An unexpected error occurred'
      }}
    >
      <BwjPageHeader
        title={'Imported Storm Doors (Lowe\'s)'}
        titleIconName={AppRoutes.importedLowesStormDoors.icon}
      />
      <BwjPageContent contentDescription={'primary content (no subcontent)'}>
        {doors.map(door =>
        <StormDoorListItem
          key={door.id}
          door={door}
          onClick={onDoorSelected}
        />)}
      </BwjPageContent>
    </BwjViewManager>
  );
};
